import styled, { keyframes } from 'styled-components';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	// top: 0;
  z-index: 11;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    // top: 30%;
		// right: 0px;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
	justify-content: center;
	align-items: center;
  background: #fff;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  width: auto;
	height: auto;
	max-width: 90%;
	max-height: 90%;
  visibility: hidden;
  transition: all 0.5s ease-out;

	scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;

  h1 {
    font-size: 18px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #455a64;
  }

	@media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 90%;
    margin-top: 0px;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		width: 100%;
		max-width: 100%;
		max-height: 100%;
		margin: 0 5px;
	}
`;

export const ContentData = styled.div`
	display: flex;
  flex-direction: column;
	justify-content: center;
	align-items: center;
  width: 100%;
  height: 100%;
	padding: 10px 20px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end; // space-between;
  align-items: center;
  background-color: #fff;
  width: 100%;
	height: 40px;
	margin: 10px 0;

  button {
    font-weight: 600;
    border-radius: 7px;
    // padding: 10px 20px;
		padding: 5px 10px;
    margin: 5px 10px;

		height: 100% !important;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);

		height: 100% !important;
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
	.button-warning {
		background-color: var(--warning-razio);
    color: #fff;
    border: 1px solid var(--warning-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
	}

	// 479px
  @media (max-width: 29.9375rem) {
		height: 60px;
	}
`;